import { ITrafficEntity } from '../apis/bidder.api';

export const parseRelatedCampaign = (entry: string): { id?: string; name: string } => {
	const separator = entry.indexOf(':');
	if (separator <= 0) {
		return { name: entry };
	}
	const id = entry.slice(0, separator);
	const name = entry.slice(separator + 1);
	return { id, name: name || entry };
};

export class TrafficEntityModel {
	id?: number;
	geo = '';
	op_system = '';
	browser = '';
	device_type = '';
	rel_camp: string[] = [];

	constructor(data?: ITrafficEntity) {
		this.id = data?.id;
		this.geo = data?.geo ?? '';
		this.op_system = data?.op_system ?? '';
		this.browser = data?.browser ?? '';
		this.device_type = data?.device_type ?? '';
		this.rel_camp = data?.rel_camp ?? [];
	}
}
